import { Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { usePlatformAdminAuthStore } from '../../stores/platform-admin-auth.store';

interface PlatformAdminProtectedRouteProps {
  children: React.ReactNode;
}

export function PlatformAdminProtectedRoute({ children }: PlatformAdminProtectedRouteProps) {
  const [isHydrated, setIsHydrated] = useState(false);
  const token = usePlatformAdminAuthStore((state) => state.token);

  useEffect(() => {
    // Wait for next tick to ensure store has hydrated
    const unsubscribe = usePlatformAdminAuthStore.persist.onFinishHydration(() => {
      setIsHydrated(true);
    });

    // Check if already hydrated
    usePlatformAdminAuthStore.persist.hasHydrated() && setIsHydrated(true);

    return unsubscribe;
  }, []);

  // Wait for store to hydrate before making routing decisions
  if (!isHydrated) {
    return null;
  }

  if (!token) {
    return <Navigate to="/platform-admin/login" replace />;
  }

  return <>{children}</>;
}
